// Игровой спрайт для NFT-фигуры: «Zombie Rook Warrior» → `/game/figures/zombie_Rook_Warrior_face.png`.
//
// 🔴 ЗАЧЕМ. Картинку из метаданных NFT показывать НЕ НАДО (решение оунера 2026-08-21): она лежит на
// внешнем домене, адрес приходит из кэша индексатора и может быть мёртвым — в профиле получались
// битые иконки. У нас есть свои спрайты тех же фигур, и владелец должен видеть в игре именно их.
//
// Опознаём фигуру по АТРИБУТАМ метаданных (`Race`/`Class`/`Subclass`), а если их нет — по имени.
// 🔴 Раса в коллекции называется «Elven», а в игре фракция — `elf`: сравнивать строки «как есть»
// нельзя, иначе половина коллекции останется без спрайта.

const TYPES = ['Pawn', 'Knight', 'Bishop', 'Rook', 'Queen', 'King'];
const RANKS = ['Warrior', 'Archer', 'Mage'];

/** Собрать одну строку из атрибутов и имени — по ней и опознаём. */
function describe(item) {
  const parts = [];
  (item.attributes || []).forEach((a) => {
    const key = String((a && (a.trait_type || a.name)) || '').toLowerCase();
    if (['race', 'class', 'subclass'].includes(key)) parts.push(String(a.value || ''));
  });
  parts.push(String(item.name || ''));
  return parts.join(' ');
}

/** Класс фигуры (`Pawn`…`King`) по данным NFT, или null. */
export function typeOf(item) {
  const text = describe(item);
  return TYPES.find((t) => new RegExp(t, 'i').test(text)) || null;
}

/** Фракция игры (`elf`/`zombie`) или null. */
export function fractionOf(item) {
  const text = describe(item).toLowerCase();
  if (/zomb/.test(text)) return 'zombie';
  if (/elv|elf/.test(text)) return 'elf';   // в коллекции раса зовётся «Elven»
  return null;
}

/**
 * Пути спрайта по убыванию точности: с подклассом → без подкласса.
 * Пустой массив — фигуру опознать не удалось (тогда интерфейс покажет номер).
 * 🔴 Кандидатов два, потому что арт есть НЕ для всех сочетаний: например, `elf_Knight_Mage`
 * не нарисован, и без запасного пути такая NFT осталась бы без картинки вовсе.
 */
export function spriteCandidates(item) {
  const text = describe(item);
  const fraction = fractionOf(item);
  const type = TYPES.find((t) => new RegExp(t, 'i').test(text));
  if (!fraction || !type) return [];
  const rank = RANKS.find((r) => new RegExp(r, 'i').test(text));
  const out = [];
  if (rank) out.push(`/game/figures/${fraction}_${type}_${rank}_face.png`);
  out.push(`/game/figures/${fraction}_${type}_face.png`);
  return out;
}

export default spriteCandidates;
